import { ContainerContent, ContainerHeader } from 'components/Containers/Containers'
import { Flex } from 'styling/GlobalStyles'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { IOpsMachineDay, IOpsWorkerDay } from 'types/opsAnalytics.interface'
import { ILiveTodaySectionProps } from 'types/opsTimelines.interface'
import { OPS_TODAY_NOW_LABEL, OPS_TODAY_NOW_MIN } from 'pages/Operations/Shared/opsAnalyticsData'
import { DayStrip } from './DayStrip'
import { LiveSection, UnlockedTag } from './Timelines.styled'

const LIVE_START_HOUR = 6

const LIVE_WINDOW_HOURS = 12

const NOW_PCT = (OPS_TODAY_NOW_MIN / (LIVE_WINDOW_HOURS * 60)) * 100

const fmtInt = (value: number): string => value.toLocaleString('en-US')

const machineTotals = (day: IOpsMachineDay): string =>
  `So far: ${day.loads} loads · ${fmtInt(day.tonnes)} t · util ${day.utilizationPct}% · ${day.smuDeltaH} h productive${day.breakdownCount > 0 ? ` · ${day.breakdownCount} breakdown` : ''}`

const workerTotals = (day: IOpsWorkerDay): string =>
  `So far: ${day.loads} loads · ${day.activeHours} h active · ${day.unassignedHours} h unassigned${day.issuesReported > 0 ? ` · ${day.issuesReported} issue reported` : ''}`

export const LiveTodaySection = ({ machineDay, workerDay }: ILiveTodaySectionProps) => {
  if (!machineDay && !workerDay) return null
  const stripLabel = machineDay
    ? `Today · ${machineDay.shiftName}${machineDay.operator ? ` · ${machineDay.operator}` : ' · unmanned'}`
    : `Today · login ${workerDay?.loginAt} → on shift`
  const totals = machineDay ? machineTotals(machineDay) : workerDay ? workerTotals(workerDay) : ''
  const segments = machineDay ? machineDay.segments : workerDay ? workerDay.segments : []
  return (
    <LiveSection>
      <ContainerHeader>
        <Flex center gap='0.75rem'>
          <TitleText>Today — in progress</TitleText>
          <UnlockedTag>UNLOCKED — becomes the record at shift end</UnlockedTag>
        </Flex>
      </ContainerHeader>
      <ContainerContent gap='0.75rem'>
        <DayStrip
          segments={segments}
          dateLabel={stripLabel}
          variant={machineDay ? 'machine' : 'worker'}
          startHour={LIVE_START_HOUR}
          windowHours={LIVE_WINDOW_HOURS}
          nowPct={NOW_PCT}
          nowLabel={OPS_TODAY_NOW_LABEL}
        />
        <BodyText weight='600'>{totals}</BodyText>
        <OtherText grey>Computed live — numbers can still change.</OtherText>
      </ContainerContent>
    </LiveSection>
  )
}
